const code = [ {
    'title': 'coding quiz',
    'image0': 'https://raw.githubusercontent.com/attila5287/img/main/quiz0.JPG',
    'image1': 'https://raw.githubusercontent.com/attila5287/img/main/quiz1.JPG',
    'image2': 'https://raw.githubusercontent.com/attila5287/img/main/quiz2.JPG',
    'url': 'https://attila5287.github.io/04_hw_quiz/',
    'desc': 'coding quiz',
    'lang': 'js',
    'serv': '',
    'libs': '',
    'date': '20-12',
    'tags': 'javascript, bootstrap'
  },
  {
    'title': 'Day Planner',
    'image0': 'https://raw.githubusercontent.com/attila5287/img/main/plan0.JPG',
    'image1': 'https://raw.githubusercontent.com/attila5287/img/main/plan1.JPG',
    'image2': 'https://raw.githubusercontent.com/attila5287/img/main/plan2.JPG',
    'url': 'https://attila5287.github.io/05_day_planner/',
    'desc': 'work day scheduler',
    'lang': 'js',
    'serv': '',
    'libs': 'jquery',
    'date': '20-12',
    'tags': 'javascript, bootstrap'
  },
  {
    'title': 'Weather Dashboard',
    'image0': 'https://raw.githubusercontent.com/attila5287/img/main/weather0.JPG',
    'image1': 'https://raw.githubusercontent.com/attila5287/img/main/weather1.JPG',
    'image2': 'https://raw.githubusercontent.com/attila5287/img/main/weather2.JPG',
    'url': 'https://attila5287.github.io/06_weather_api/Master/',
    'desc': 'open weather API',
    'lang': 'js',
    'serv': '',
    'libs': 'jquery',
    'date': '21-01',
    'tags': 'javascript, bootstrap'
  },
  {
    'title': 'PDF Generator',
    'image0': 'https://raw.githubusercontent.com/attila5287/img/main/pdf0.JPG',
    'image1': 'https://raw.githubusercontent.com/attila5287/img/main/pdf1.JPG',
    'image2': 'https://raw.githubusercontent.com/attila5287/img/main/pdf2.JPG',
    'url': 'https://github.com/attila5287/node_js/tree/main/pdf_generator',
    'desc': 'github API to pull developer info',
    'lang': 'js',
    'serv': 'node',
    'libs': 'nodejs, axios',
    'date': '21-01',
    'tags': 'javascript, bootstrap'
  },
  {
    'title': 'Markdown Generator',
    'image0': 'https://raw.githubusercontent.com/attila5287/img/main/md0.JPG',
    'image1': 'https://raw.githubusercontent.com/attila5287/img/main/md1.JPG',
    'image2': 'https://raw.githubusercontent.com/attila5287/img/main/md2.JPG',
    'url': 'https://github.com/attila5287/node_js/tree/main/markdown_gen',
    'desc': 'collect repo info with Inquirer then generate a markdown file',
    'lang': 'js',
    'serv': 'node',
    'libs': 'inquirer, nodejs',
    'date': '21-02',
    'tags': 'javascript, bootstrap'
  },
  {
    'title': 'OOP HTML Generator',
    'image0': 'https://raw.githubusercontent.com/attila5287/img/main/oop0.JPG',
    'image1': 'https://raw.githubusercontent.com/attila5287/img/main/oop1.JPG',
    'image2': 'https://raw.githubusercontent.com/attila5287/img/main/oop2.JPG',
    'url': 'https://github.com/attila5287/node_js/tree/main/OOP_html_gen',
    'desc': 'object oriented programming with javascript, collect developer info from user-manager  with inquirer then generate HTML doc with bootstrap',
    'lang': 'js',
    'serv': 'node',
    'libs': 'inquirer,',
    'date': '21-02',
    'tags': 'javascript, bootstrap'
  },
  {
    'title': 'Note Taker',
    'image0': 'https://raw.githubusercontent.com/attila5287/img/main/note0.JPG',
    'image1': 'https://raw.githubusercontent.com/attila5287/img/main/note1.JPG',
    'image2': 'https://raw.githubusercontent.com/attila5287/img/main/note2.JPG',
    'url': 'https://notetakerhero.herokuapp.com/',
    'desc': 'TODO app with no database, instead used localStorage mocking a db',
    'lang': 'js',
    'serv': 'node',
    'libs': 'localStorage, express',
    'date': '21-03',
    'tags': 'javascript, bootstrap, heroku, database'
  },
  {
    'title': 'TripMySQL',
    'image0': 'https://raw.githubusercontent.com/attila5287/img/main/trip0.JPG',
    'image1': 'https://raw.githubusercontent.com/attila5287/img/main/trip1.JPG',
    'image2': 'https://raw.githubusercontent.com/attila5287/img/main/trip2.JPG',
    'url': 'http://tripmysql.herokuapp.com/',
    'desc': 'users create trips with forms, SQL for database and ORM, object relational modeling',
    'lang': 'js',
    'serv': 'node',
    'libs': 'jawsDB, sql, express',
    'date': '21-03',
    'tags': 'javascript, bootstrap, sql, ORM, heroku, database'
  },
  {
    'title': 'E-Commerce SQL',
    'image0': 'https://raw.githubusercontent.com/attila5287/img/main/ecom0.JPG',
    'image1': 'https://raw.githubusercontent.com/attila5287/img/main/ecom1.JPG',
    'image2': 'https://raw.githubusercontent.com/attila5287/img/main/ecom2.JPG',
    'url': 'http://ecommsql.herokuapp.com/',
    'desc': 'user create products via forms, stores to database, SQL',
    'lang': 'js',
    'serv': 'node',
    'libs': 'jawsDB, express',
    'date': '21-03',
    'tags': 'javascript, bootstrap, heroku, database, ORM, SQL'
  },
  {
    'title': 'MVC Project Funder',
    'image0': 'https://raw.githubusercontent.com/attila5287/img/main/pro0.JPG',
    'image1': 'https://raw.githubusercontent.com/attila5287/img/main/pro1.JPG',
    'image2': 'https://raw.githubusercontent.com/attila5287/img/main/pro2.JPG',
    'url': 'https://mvcprofunder.herokuapp.com',
    'desc': 'MVC model view controller diagram, kickstarter-like app',
    'lang': 'js',
    'serv': 'node',
    'libs': 'express',
    'date': '21-04',
    'tags': 'javascript, bootstrap, MVC, heroku, ORM, database, CRUD'
  },
  {
    'title': 'MVC Tech Blogger',
    'image0': 'https://raw.githubusercontent.com/attila5287/img/main/blog0.JPG',
    'image1': 'https://raw.githubusercontent.com/attila5287/img/main/blog1.JPG',
    'image2': 'https://raw.githubusercontent.com/attila5287/img/main/blog2.JPG',
    'url': 'https://mvctechblogger.herokuapp.com/',
    'desc': 'blogger app with MVC paradigm, users create account, login and view dashboard, creates an edits blog posts',
    'lang': 'js',
    'serv': 'node',
    'libs': 'express',
    'date': '21-04',
    'tags': 'javascript, bootstrap, SQL, ORM, heroku, CRUD'
  },
  {
    'title': 'Budget Tracker',
    'image0': 'https://raw.githubusercontent.com/attila5287/img/main/bud0.JPG',
    'image1': 'https://raw.githubusercontent.com/attila5287/img/main/bud1.JPG',
    'image2': 'https://raw.githubusercontent.com/attila5287/img/main/bud2.JPG',
    'url': 'http://mongobudget.herokuapp.com/',
    'desc': 'budget tracker with mongo database, also works offline',
    'lang': 'js',
    'serv': 'node',
    'libs': 'indexedDB, mongoose',
    'date': '21-04',
    'tags': 'javascript, bootstrap, heroku, ORM'
  },
  {
    'title': 'Fitness Tracker',
    'image0': 'https://raw.githubusercontent.com/attila5287/img/main/fit0.JPG',
    'image1': 'https://raw.githubusercontent.com/attila5287/img/main/fit1.JPG',
    'image2': 'https://raw.githubusercontent.com/attila5287/img/main/fit2.JPG',
    'url': 'http://mongofitness.herokuapp.com',
    'desc': 'create and edit workouts exercise by ex',
    'lang': 'js',
    'serv': 'node',
    'libs': 'mongoose',
    'date': '21-04',
    'tags': 'javascript, bootstrap, heroku, ORM'
  },
  {
    'title': 'React Pupster',
    'image0': 'https://raw.githubusercontent.com/attila5287/img/main/pup0.JPG',
    'image1': 'https://raw.githubusercontent.com/attila5287/img/main/pup1.JPG',
    'image2': 'https://raw.githubusercontent.com/attila5287/img/main/pup2.JPG',
    'url': 'http://reactpups.herokuapp.com/',
    'desc': 'tinder-like app for dog-lovers, like puppies and if puppy likes the user, there will be a match, also enables user perform a search by breed',
    'lang': 'js',
    'serv': 'node',
    'libs': 'react',
    'date': '21-05',
    'tags': 'javascript, bootstrap'
  },
  {
    'title': 'React Employee',
    'image0': 'https://raw.githubusercontent.com/attila5287/img/main/emp0.JPG',
    'image1': 'https://raw.githubusercontent.com/attila5287/img/main/emp1.JPG',
    'image2': 'https://raw.githubusercontent.com/attila5287/img/main/emp2.JPG',
    'url': 'https://attila5287.github.io/reactemployee/',
    'desc': 'employee directory with react UI interface, performs search and renders simultaneously',
    'lang': 'js',
    'serv': 'node',
    'libs': 'react',
    'date': '21-05',
    'tags': 'javascript, bootstrap, react'
  },
];
export default code;
